import { call, put, takeLatest } from "redux-saga/effects";
import { getRepairDefectsDetailListByIdApi, getRepairsListApi } from "../requests/repairsRequests";
import { toast } from "react-toastify";
import { RepairsActions } from "../../action-types/repairsActionType";
import { setRepairDefectsDetailsByIdList, setRepairsList, setRepairsPaginationList } from "../../actions/repairsAction";
import { setLoader } from "../../actions/userActions";

function* getRepairsHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getRepairsListApi, action.payload);
    if (data.status) {
      yield put(setRepairsList(data.data));
      yield put(setRepairsPaginationList(data.pagination));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* getRepairDefectsDetailListByIdHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getRepairDefectsDetailListByIdApi, action.payload?.id);
    if (data.status) {
      yield put(setRepairDefectsDetailsByIdList(data.data));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

// accountHandler Sagas
export default function* repairsSaga() {
  yield takeLatest(RepairsActions.GET_REPAIRS_LIST, getRepairsHandler);
  yield takeLatest(RepairsActions.GET_REPAIRS_DEFECTS_DETAILS_BY_ID_LIST, getRepairDefectsDetailListByIdHandler);
}
